define('modules/form_editor/views/preview_radio_group',['require','exports','module','./preview_check_group','./preview_radio_item','../../editor/models/editorstate','ldsh!../templates/preview_check_group_amp','ldsh!../templates/preview_group'],function(require, exports, module){
  "use strict";
  var InputCheckGroup = require("./preview_check_group"),
      InputRadioItem = require("./preview_radio_item"),
      EditorState = require("../../editor/models/editorstate");

  module.exports = InputCheckGroup.extend({
    template: null,
    itemView: InputRadioItem,
    initialize: function(options){
    this.template = EditorState.getAMPState() ?
      require("ldsh!../templates/preview_check_group_amp") : require("ldsh!../templates/preview_group");
    module.exports.__super__.initialize.apply(this, arguments);
    }
  });
});

